export const maskSSN = (SSN: string | null) => {
	const _ssn = SSN?.substring(5, 9);
	return _ssn;
};

export const maskedSSN = (SSN: string | null) => {
	if (SSN && SSN.includes("-")) {
		const formattedSSN = SSN?.split("-").join("");
		const _ssn = formattedSSN?.substring(5, 9);
		return "XXX-XX-" + _ssn;
	}
	const _ssn = SSN?.substring(5, 9);
	return "XXX-XX-" + _ssn;
};
